import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConnectionService } from './connection.service';
import { EmailInterface } from '@contracts/interfaces/email.interface';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CSVService {


    constructor(private http: HttpClient,
        private connectionService: ConnectionService ) {}

    fileToJSON(file: File) {
        const formData: FormData = new FormData();
        formData.append('file', file);
    
        return this.http.post(this.connectionService.address + '/csv-service/file-to-json', formData, {
          reportProgress: true,
          observe: 'events'
        }).pipe(map((r: any) => {
            return r.body;
        }));
    }
}